import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators, ReactiveFormsModule } from '@angular/forms';
import { PointBaseline } from 'src/app/api/api-campaigns.service.generated';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-staff-point-baseline',
    templateUrl: './staff-point-baseline.component.html',
    styleUrls: ['./staff-point-baseline.component.scss'],

    imports: [
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StaffPointBaselineComponent),
            multi: true
        }],

})
export class StaffPointBaselineComponent implements ControlValueAccessor {

  grp = new FormGroup({
    isRequired: new FormControl(false),
    belowThresholdMultiplier: new FormControl(null, Validators.required),
    aboveThresholdMultiplier: new FormControl(null, Validators.required)
  });

  constructor() {
    this.grp.valueChanges.subscribe(_ => this.notifyFormChanged());
  }

  /// ControlValueAccessor-------------------
  @Input('value') _value: any;
  onChange: any = () => {};
  onTouched: any = () => {};
  get value(): PointBaseline {
    return this._value;
  }
  set value(o: PointBaseline) {

    this._value = o;

    this.grp.patchValue({
      ...o
    }, { emitEvent: false });

    this.onChange(o);
    this.onTouched();
  }


  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(_isDisabled: boolean): void {
  }
  /// ControlValueAccessor------------------

  notifyFormChanged() {
    const o = this.getFormData();
    this._value = o;
    this.onChange(o);
    this.onTouched();
  }

  getFormData(): PointBaseline {
    const f = this.grp.value;

    if (f.isRequired && !f.belowThresholdMultiplier && !f.aboveThresholdMultiplier)
    return undefined;

    return new PointBaseline({
      isRequired: f.isRequired,
      belowThresholdMultiplier: !f.isRequired ? 1 : +f.belowThresholdMultiplier,
      aboveThresholdMultiplier: !f.isRequired ? 1 : +f.aboveThresholdMultiplier,
    });
  }
}